import React from 'react';

import {Container} from '@mui/material';
import {Outlet} from 'react-router-dom';

function GuestPageFrame(): JSX.Element {
  return (
    <Container component="main" sx={{display: 'flex', justifyContent: 'center', p: 1}}>
      <Outlet />
    </Container>
  );
}

export default React.memo(GuestPageFrame);
